import { render } from "./CreateAugmentedRealityFeatureModal.vue?vue&type=template&id=4e7a44ce"
import script from "./CreateAugmentedRealityFeatureModal.vue?vue&type=script&lang=js"
export * from "./CreateAugmentedRealityFeatureModal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "4e7a44ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e7a44ce', script)) {
    api.reload('4e7a44ce', script)
  }
  
  module.hot.accept("./CreateAugmentedRealityFeatureModal.vue?vue&type=template&id=4e7a44ce", () => {
    api.rerender('4e7a44ce', render)
  })

}

script.__file = "resources/js/Pages/Station/Partials/Features/AugmentedReality/CreateAugmentedRealityFeatureModal.vue"

export default script